import React, { useRef } from "react";
import ImageMaskEditor from "components/images/editor/ImageMaskEditor";
import { Button, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import ImageEditorControls from "components/images/editor/ImageEditorControls";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import EditImageButton from "./EditImageButton";
import UploadMaskButton from "./UploadMaskButton";
import DownloadMaskButton from "./DownloadMaskButton";
import InvertMaskButton from "./InvertMaskButton";
import ResetMaskButton from "./ResetMaskButton";
import { useTheme } from "@emotion/react";
import { fonts } from "fonts";
import { useDispatch, useSelector } from "react-redux";
import HorizontalGallery from "components/images/HorizontalGallery";
import { selectQueryState } from "store/firestore";
import {
  DOWNLOAD_IMAGE_MENU_ITEM,
} from "components/images/imageUtils";
import { imageEditorActions } from "../../../store/imageEditor";

export default function ImageEditor() {
  
  const dispatch = useDispatch();

  const generatedImagesState = useSelector((state) =>
    selectQueryState(state, "generatedImages")
  );
  const editorRef = useRef(null);
  const theme = useTheme();

  const handleEdit = (generatedImage) => {
    const url = generatedImage.image.imageUrl;
    if(editorRef.current.handleUrlImage) {
      editorRef.current.handleUrlImage(url);
    }
  }

  const handleUsePrompt = (generatedImage) => {
    dispatch(imageEditorActions.setPrompt(generatedImage.prompt));
  }

  const menuItems = [
    {
      label: "Edit",
      action: handleEdit,
    },
    DOWNLOAD_IMAGE_MENU_ITEM,
    {
      label: "Use Prompt",
      action: handleUsePrompt,
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12} p={2}>
        <HorizontalGallery
          loading={generatedImagesState.loading}
          images={generatedImagesState.docs}
          size={150}
          showMenu={false}
          // onClick={handleImageClick}
          menuItems={menuItems}
        />
      </Grid>
      <Grid item xs={12} p={2}>
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.main,
          }}
          fontFamily={fonts.geist}
        >
          Masking is only supported by <b>GPT Image</b>. The model tries to only
          edit the masked region, but the results might not always be perfect.
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ImageMaskEditor ref={editorRef} />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          position: "sticky",
          top: 0,
          alignSelf: "flex-start", // ensures it aligns to the top of the container
          height: "fit-content", // so it doesn’t stretch to full height
        }}
      >
        <Stack p={2} spacing={2}>
          <ImageEditorControls editorRef={editorRef} />
          <EditImageButton editorRef={editorRef} />
          <InvertMaskButton />
          <ResetMaskButton />
          <UploadMaskButton />
          <DownloadMaskButton />
        </Stack>
      </Grid>
    </Grid>
  );
}
